import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function AdminSubscribers() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/admin/subscribers").then((r) => setItems(r.data));
  }, []);

  const exportCsv = () => {
    const csv = ["email,created_at", ...items.map((s) => `${s.email},${s.created_at}`)].join("\n");
    const blob = new Blob([csv], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url; a.download = "aeras-subscribers.csv"; a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="p-8 md:p-12" data-testid="admin-subscribers">
      <div className="flex items-baseline justify-between mb-12">
        <div>
          <div className="font-mono text-[10px] tracking-[0.3em] text-[#007A8A] mb-2">— NEWSLETTER</div>
          <h1 className="font-display text-5xl md:text-6xl tracking-tighter">Iscritti · {items.length}</h1>
        </div>
        <button onClick={exportCsv} className="btn-ghost" data-testid="export-csv">Export CSV</button>
      </div>

      <div className="border border-[#e4e4e7]">
        <table className="w-full text-sm font-body">
          <thead>
            <tr className="border-b border-[#e4e4e7] font-mono text-[10px] tracking-widest uppercase text-[#3f3f46]">
              <th className="text-left p-4">Email</th>
              <th className="text-left p-4">Data iscrizione</th>
            </tr>
          </thead>
          <tbody>
            {items.map((s) => (
              <tr key={s.id} className="border-b border-[#e4e4e7] hover:bg-[#f4f4f5]">
                <td className="p-4"><a className="text-[#007A8A] aero-link" href={`mailto:${s.email}`}>{s.email}</a></td>
                <td className="p-4 font-mono text-xs text-[#3f3f46]">{new Date(s.created_at).toLocaleString("it-IT")}</td>
              </tr>
            ))}
            {items.length === 0 && <tr><td colSpan="2" className="p-8 text-center text-[#52525b]">Nessun iscritto.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
